// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionReportActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import { curry, isNil } from 'lodash/fp';
import { PERMISSION_KEY } from 'logic/data/Izenda.AuthorizationConstants';

/**
 * OnChange simple data source
 * @param {Object} props
 * @param {Boolean} value
 */
const onChangeSimpleDataSource = (props: any, radio: Boolean) => {
  const checked = radio.target.checked;
  props.permission.toggleReportDataSources(checked);
};

/**
 * OnChange simple data source
 * @param {Object} props
 * @param {Boolean} value
 */
const onChangeAdvancedDataSource = (props: any, radio: Boolean) => {
  const checked = radio.target.checked;
  props.permission.toggleReportDataSources(!checked);
};

/**
 * Permission Update Data
 * @param {Object} props
 * @param {Object} data
 * @param {String} value
 * @param {Object} event
 */
const permissionUpdateData = (props: any, data: any, value: string, event: any) => {
  props.permission.updateData(data, value, event.target.checked);
};

/**
 * onChange Map handler
 * @param {Object} props
 * @param {Object} data
 * @param {String} value
 * @param {Object} event
 */
const onMapChange = (props: any, data: any, value: string, event: any) => {
  const enableMap = event.target.checked;
  props.permission.updateData(data, value, enableMap);

  updateIsEnableGoogleAddress(props, enableMap, data);
};

/**
 * Permission Update Tenant Access
 * @param {Object} props
 * @param {Object} data
 * @param {Object} value
 * @param {Object} event
 */
const permissionUpdateTenantAccess = (props: any, data: any, value: any, event: any) => {
  props.permission.updateTenantAccess(data, value, event.target.checked);
};

export default withHandlers({
  onChangeSimpleDataSource: curry(onChangeSimpleDataSource),
  onChangeAdvancedDataSource: curry(onChangeAdvancedDataSource),
  permissionUpdateData: curry(permissionUpdateData),
  permissionUpdateTenantAccess: curry(permissionUpdateTenantAccess),
  onMapChange: curry(onMapChange)
});

function updateIsEnableGoogleAddress(props, enableMap, data) {
  const {
    permission: { isTenantSetup },
    permissionStore: { tenantDetail }
  } = props;

  const isSettingForTenantOnSystemLevel = isNil(tenantDetail) && isTenantSetup;

  isSettingForTenantOnSystemLevel &&
    !enableMap &&
    props.permission.updateData(data, 'isEnableGoogleAddress', enableMap);
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.PermissionReportActions.js